import { Marketplace, AsinSeed, AsinSeedTypeEnum, MatchType } from "@front/m19-api-client";
import { CsvSeedType, CsvMatchType } from "./catalog.component";

export class SeedCsvRow {
  constructor(
    public asin: string,
    public type: CsvSeedType,
    public matchType: CsvMatchType,
    public value: string,
  ) {}

  public toAsinSeed(accountId: string, marketplace: Marketplace): AsinSeed {
    return {
      accountId: accountId,
      marketplace: marketplace,
      asin: this.asin,
      type: this.type === CsvSeedType.SEED ? AsinSeedTypeEnum.WHITELIST : AsinSeedTypeEnum.BLACKLIST,
      matchType: SeedCsvRow.toMatchType(this.matchType),
      targetingValue: this.value,
    };
  }

  private static fromMatchType(matchType: MatchType): CsvMatchType {
    switch (matchType) {
      case MatchType.exact:
        return CsvMatchType.exact;
      case MatchType.phrase:
        return CsvMatchType.phrase;
      case MatchType.asinSameAs:
        return CsvMatchType.targetedProduct;
    }
  }

  private static toMatchType(matchType: CsvMatchType): MatchType {
    switch (matchType) {
      case CsvMatchType.exact:
        return MatchType.exact;
      case CsvMatchType.phrase:
        return MatchType.phrase;
      case CsvMatchType.targetedProduct:
        return MatchType.asinSameAs;
    }
  }

  public static fromAsinSeed(asinSeeds: AsinSeed[]): SeedCsvRow | null {
    if (asinSeeds.length == 0) {
      return null;
    }
    return new SeedCsvRow(
      asinSeeds[0].asin!,
      asinSeeds[0].type === AsinSeedTypeEnum.WHITELIST ? CsvSeedType.SEED : CsvSeedType.BLACKLIST,
      SeedCsvRow.fromMatchType(asinSeeds[0].matchType!),
      asinSeeds.map((a) => a.targetingValue).join(","),
    );
  }
}
